const Form081TC = {
    stepName: {
        importantNotes: "重要事項",
        selectSchool: "學校類別",
        partA: "尚未成立法團校董會的學校",
        partB: "已成立法團校董會的學校",
        confirmation: "確認頁面",
    },
    noteList: {
        note1: "註1：如該無薪假期最後一日之翌日為星期日或憲報公布之公眾假期，則該星期日或憲報公布之公眾假期將被視為無薪假期之延續。如該無薪假期最後一日之翌日為主要的學校假期，包括聖誕節假期、農曆新年假期、復活節假期及暑假，其薪酬會於該教師向學校報到並復工當日起恢復。故此，該教師的無薪假期申請必須包括這些屬於無薪假期延續的日子。",
        note2: "註2：須預先獲有關的學校發展主任確認。",
        note3A: "註3：有關(a)至(d)項所列的無薪假期間因法例規定的責任而引致的開支，資助學校請參閱該學年「資助學校的營辦開支整筆津貼(營辦津貼)／擴大的營辦開支整筆津貼(擴大的營辦津貼)及綜合家具及設備津貼」的通函，以及上載於教育局網頁的營辦津貼運用指引。",
        note3B: "註3：有關(a)至(d)項所列的無薪假期間因法例規定的責任而引致的開支，資助學校請參閱該學年「資助學校的營辦開支整筆津貼(營辦津貼)／擴大的營辦開支整筆津貼(擴大的營辦津貼)及綜合家具及設備津貼」的通函，以及上載於教育局網頁的擴大的營辦津貼運用指引。",
        importantNotesStatement: "無薪假期申請表／批准通知書個人資料收集聲明",
        part1Title: "收集個人資料的目的",
        importantNotesPurpose:
            "1.	你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        importantNotesA: "處理、核實及查證就無薪假期的申請／批准通知； ",
        importantNotesB:
            "就上文(a)項所述申請／批准通知的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對； ",
        importantNotesC:
            "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
        importantNotesD:
            "培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        importantNotesE:
            "處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計；",
        importantNotesF: "編製統計資料、研究及政府刊物；以及",
        importantNotesG:
            "執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》]。",
        // importantNotesObligatory:
        //     "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        // importantNotesDisclosed:
        //     "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        // importantNotesRights:
        //     "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        // importantNotesConcern:
        //     "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
        checked: "本人已檢閱",
        part2: "2.	你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理有關申請／批准通知。",
        part3Title: "可獲轉移資料者",
        part3: "3.	你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        part3a: "政府其他政策局及部門，以用於上文第1段所述的用途；",
        part3b: "與本表格相關的學校，以用於上文第1段所述的用途；",
        part3c: "你曾就披露個人資料給予訂明同意；以及",
        part3d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        part4Title: "查閱個人資料",
        part4: '4.	你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向有關高級學校發展主任提出，並寄交教育局網頁(<a href="https://www.edb.gov.hk/en/contact-us/reo.html" target="_blank">https://www.edb.gov.hk/en/contact-us/reo.html</a>)所載區域教育服務處地址或電郵至<a href="mailto:edbinfo@edb.gov.hk">edbinfo@edb.gov.hk</a>。',
        and: "提交的：",
        confirmValid1:
            "相關證明文件並確認其有效。[只適用於(a)項所列的假期類別]",
        confirmValid2:
            "相關證明文件並確認其有效，現隨函夾附有關的證明文件以便貴局處理申請。此外，本人亦已通知",
        confirmValid2B:
            "相關證明文件並確認其有效。本人明白教育局或要求本校提供有關上述無薪假期申請的證明文件。此外，本人亦已通知",
        confirmValid3:
            "須於上述無薪假期最後一日之翌日向學校報到並復工，以便學校於其復工當日起恢復支付其薪酬。[只適用於(b)至(e)項所列的假期類別]",
        declaration1: "{{addition}}",
        declaration1Option: {
            approval: "請批准{{name}}{{title}}在上述期間放取無薪假期並保留該員",
            open: "請批准保留{{name}}{{title}}",
        },
        declaration1Option2: {
            approval:
                "請批准 <b>{{name}}{{title}}</b> 在上述期間放取無薪假期並保留該員",
            open: "請批准保留 <b>{{name}}{{title}}</b>",
        },

        // declaration4: "在上述期間放取無薪假期，請批準保留該員在",
        declaration4: "在",

        declarationFrom: "",
        declarationFrom2: "上述期間放取無薪假期，請批准保留該員在",
        declarationTo: "至",
        declaration2:
            "(首尾兩天包括在內)的公積金賬戶。該員的無薪假期將不會算作公積金供款的無間斷年資。",
        declaration3A:
            "本人明白學校必須自行承擔履行一切法例規定的責任，包括支付因教師放取無薪假期而可能引致的任何開支，例如法定假日的開支 ",
        declaration3B:
            "本人亦明白學校必須自行承擔履行一切法例規定的責任，包括支付因教師放取無薪假期而可能引致的任何開支，例如法定假日的開支 ",
    },
    label: {
        msgList: {
            msg1: "致：",
            msg2: "區域教育服務處高級學校發展主任",
            msg3: "副本：",
            msg4: "財政科高級會計主任(公積金)",
            msg5: "第二副本：",
            msg6: "放取假期的學校",
            msg7: "",
            msg8: "先生/女士：",
            msg9A: "校長/教師",
            msg9B: "校長/教師",
            msg10: "無薪假期",
            msg11: "本校",
            msg12: "",
            msg13: "於",
            msg14: "申請放取無薪假期。",
            msg15: "本校已",
            msg16: "申請由",
            msg17: "至",
            msg18: "(首尾兩天包括在內)",
            msg19: "由於",
            msg20: "天無薪假期，",
            msg21: "天無薪假期，其增薪日期",
            msg22: "至",
            msg23: "月一日。",
            msg24: "。",
        },
        schoolType: "請選擇學校類別",
        date: "日期",
        SSDO: "高級學校發展主任",
        nameOfSchool: "學校名稱",
        nameOf: "姓名",
        name: "姓名",
        headOrTeacher: "校長／教師",
        nameOfHeadOrTeacher: "校長／教師姓名",
        rank: "職系",
        rankWithBracket: "(職系)",
        textBeforeNoPayLeaveDay: "放取共",
        textAfterNoPayLeaveDay: "天的無薪假期，",
        note1: "註1",
        onGroundOf: "其申請理由是",
        sickOrMaternityOrSpecialTubLeave: "病假／產假／肺病特別假期",
        fullStop: "。",
        fullStop2: "。",
        comma: "，",
        studyLeave: "為參加與教育有關課程而放取的進修假期。(請註明)",
        courseName: "課程名稱",
        organizingIns: "主辦院校",
        healthLeave: "由有效的醫生證明書證明因健康理由而需放取的假期。",
        redundantLeaveText1: "為解決",
        redundantLeaveText2: "因超額教師問題而放取的假期",
        note2: "註2",
        school: "本校／相同辦學團體的學校",
        plsSpecifyNameOfOtherSchool: "(請註明該學校的名稱",
        otherLeave: "因私人原因而放取的其他假期。",
        otherReason: "(請註明原因",
        reason: "原因",
        from: "由",
        ofMySchoolDated: "申請於",
        notifyAsFollows: "放取無薪假期，現特通知如下。",
        hasBeenGiven: "批准",
        toTakeNoPayLeaveOf: "放取共",
        willBeAdjusted: "其增薪日期將調整至",
        hasBeenGranted: "獲准放取",
        note3: "註3",
        will: "將",
        unchange: "維持不變",
    },
    formContent: {
        schoolTypeOption: {
            PartA: "尚未成立法團校董會的學校",
            PartB: "已成立法團校董會的學校",
        },
        titleOption: {
            Mr: "先生",
            Ms: "女士",
        },
        appliedOrGrantedOption1: {
            applied: "接獲",
            granted: "批准",
        },
        appliedOrGrantedOption2: {
            applied: "申請",
            granted: "獲准放取",
        },
        headOrTeacherOption: {
            head: "校長",
            teacher: "教師",
        },
        leaveOption: {
            sickLeave: "病假",
            maternityLeave: "產假",
            specialTubLeave: "肺病特別假期",
        },
        mySchoolOrAnotherSchoolOption: {
            mySchool: "本校",
            anotherSchool: "相同辦學團體的學校",
        },
        adjustedOption: {
            will: "將調整(如獲批准)",
            is: "已調整",
        },
        monthOption: {
            1: "一",
            2: "二",
            3: "三",
            4: "四",
            5: "五",
            6: "六",
            7: "七",
            8: "八",
            9: "九",
            10: "十",
            11: "十一",
            12: "十二",
            na: "不適用",
        },
        SSDOOption: {
            e: "東區",
            i: "離島區",
            k: "觀塘區",
            kc: "九龍城區",
            kt: "葵青區",
            m: "中西區",
            n: "北區",
            s: "南區",
            sk: "西貢區",
            ssp: "深水埗區",
            st: "沙田區",
            tm: "屯門區",
            tp: "大埔區",
            tw: "荃灣區",
            w: "灣仔區",
            wts: "黃大仙區",
            y: "元朗區",
            ytm: "油尖旺區",
        },
        numberList: {
            a: "(a)",
            b: "(b)",
            c: "(c)",
            d: "(d)",
            e: "(e)",
        },
    },
    errorMsg: {
        option: "請選擇最少一個申請理由",
    },
};
export default Form081TC;
